

























































import Vue from 'vue'

const pageSize = 5

export default Vue.extend({
    data: () => {
        return {
            address: '',
            items: null as Connex.VM.Event[] | null,
            error: null as Error | null,
            loading: false,
            offset: 0
        }
    },
    computed: {
        canNext() { return this.items && this.items.length === pageSize },
        canPrev() { return this.items && this.offset > 0 },
        range() {
            if (!this.loading && this.items && this.items.length > 0) {
                return [this.offset, this.offset + this.items.length]
            }
            return null
        }
    },
    methods: {
        nextPage() {
            this.offset += pageSize
            this.reload()
        },
        prevPage() {
            if (this.offset >= pageSize) {
                this.offset -= pageSize
                this.reload()
            }
        },
        async reload() {
            if (this.loading) {
                return
            }
            try {
                this.loading = true
                this.error = null
                this.items = await this.$connex.thor.filter('event', [{ address: this.address }])
                    .order('desc')
                    .apply(this.offset, pageSize)
            } catch (err) {
                this.error = err
            } finally {
                this.loading = false
            }
        }
    },
    created() {
        this.address = this.$route.params.address.toLowerCase()
        this.reload()
    }
})
